import { useEffect, useState } from "react";
import styles from "./Navbar.module.css";
import LOGO from "../assets/listen-to-delhi-logo-500x500.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSquareFacebook,
  faSquareInstagram,
} from "@fortawesome/free-brands-svg-icons";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Navbar = (props) => {
  const [isActive, setIsActive] = useState(false);
  const [language, setLanguage] = useState(
    localStorage.getItem("activeLang") || "NO",
  );
  const navigate = useNavigate();

  console.log(language);

  const { t, i18n } = useTranslation();

  const toggleActiveClass = () => {
    setIsActive(!isActive);
  };

  const location = useLocation();

  const [scrollTarget, setScrollTarget] = useState(null);

  const gotoAbout = () => {
    setIsActive(false);

    if (location.pathname !== "/") {
      setScrollTarget("about");
      navigate("/");
    } else {
      scrollToSection("about");
    }
  };

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (!element) return;
    const y = element.getBoundingClientRect().top + window.scrollY - 120;
    window.scrollTo({
      top: y,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    if (location.pathname === "/" && scrollTarget) {
      const frame = requestAnimationFrame(() => {
        scrollToSection(scrollTarget);
        setScrollTarget(null);
      });

      return () => cancelAnimationFrame(frame);
    }
  }, [location.pathname, scrollTarget]);

  const gotoMenu = () => {
    setIsActive(false);

    if (location.pathname !== "/") {
      navigate("/");
    } else {
      const y =
        document.getElementById("menu").getBoundingClientRect().top +
        window.pageYOffset -
        132;
      window.scrollTo({
        top: y,
        behavior: "smooth",
      });
    }
  };

  const gotoContact = () => {
    setIsActive(false);

    // if (location.pathname !== "/") {
    //   navigate("/");
    // } else {
      const y =
        document.getElementById("footer").getBoundingClientRect().top +
        window.pageYOffset -
        130;
      window.scrollTo({
        top: y,
        behavior: "smooth",
      });
    // }
  };

  const gotoCatering = () => {
    navigate("/catering");
    setIsActive(false);
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="header-bg">
      <header className="App-header">
        <div className={`${styles.logo}`}>
          <Link to={"/"}>
            <img
              src={LOGO}
              alt="Logo"
              className="App-logo"
              onClick={scrollToTop}
            />{" "}
          </Link>
        </div>
        <nav className={`${styles.navbar}`}>
          <ul className={`${styles.navMenu} ${isActive ? styles.active : ""}`}>
            <li onClick={gotoAbout} className="navLink">
              <span>{t("nav_about_us")}</span>
            </li>
            <li onClick={gotoMenu} className="navLink">
              <span>{t("nav_menu")}</span>
            </li>
            <li onClick={gotoContact} className="navLink">
              <span> {t("nav_contact_us")}</span>
            </li>
            <li onClick={gotoCatering} className="navLink">
              <span> {t("Catering")}</span>
            </li>
          </ul>
        </nav>
        <nav className={`${styles.navbar}`}>
          <ul className={`${styles.navOrderMenu}`}>
            <li className="l_navLink">
              <Link
                to={
                  "https://book.dinnerbooking.com/no/nb-NO/book/index/2183/2?_gl=1*tfy04i*_gcl_au*Mjc3NjM1MDU3LjE3NjQ5MTkwMjY.*_ga*MTU2MTMzODUwNC4xNzU3MDQ3NzQ2*_ga_LXPDS7PHH3*czE3NjgyMTEzOTQkbzE5JGcwJHQxNzY4MjExMzk0JGo2MCRsMCRoMA"
                }
              >
                <span>{t("book_table_btn")}</span>
              </Link>
            </li>

            <li className="l_navLink">
              <Link to={"https://listentodelhi.nemtakeaway.no/"}>
                <span>{t("take_away_btn")}</span>
              </Link>
            </li>
          </ul>

          <div className="social">
            <div>
              <Link
                to={"https://www.facebook.com/Listentodelhi/"}
                target="_blank"
                aria-label="Visit our Facebook page"
              >
                <FontAwesomeIcon
                  icon={faSquareFacebook}
                  style={{
                    color: "#2b4e81",
                    paddingRight: "5px",
                    fontSize: "25px",
                  }}
                  className="hover-scale"
                />
              </Link>
              <Link
                to={"https://www.instagram.com/listentodelhioslo/"}
                target="_blank"
                aria-label="Visit our Instagram page"
              >
                <FontAwesomeIcon
                  icon={faSquareInstagram}
                  style={{
                    color: "#2b4e81",
                    paddingLeft: "6px",
                    fontSize: "25px",
                  }}
                  className="hover-scale"
                />
              </Link>
            </div>

            <div>
              <span
                className={`lang ${language === "NO" ? "langActive" : ""}`}
                style={{ fontSize: "1em", paddingLeft: "-1px" }}
                onClick={() => {
                  setLanguage("NO");
                  i18n.changeLanguage("NO");
                  localStorage.setItem("lang", "NO");
                  localStorage.setItem("activeLang", "NO");
                }}
              >
                NO
              </span>
              <span style={{ fontSize: "1em" }}>|</span>
              <span
                className={`lang  ${language === "EN" ? "langActive" : ""}`}
                style={{ fontSize: "1em" }}
                onClick={() => {
                  setLanguage("EN");
                  i18n.changeLanguage("EN");
                  localStorage.setItem("lang", "EN");
                  localStorage.setItem("activeLang", "EN");
                }}
              >
                EN
              </span>
            </div>
          </div>
          <div
            className={`${styles.hamburger} ${isActive ? styles.active : ""}`}
            onClick={toggleActiveClass}
          >
            <span className={`${styles.bar}`}></span>
            <span className={`${styles.bar}`}></span>
            <span className={`${styles.bar}`}></span>
          </div>
        </nav>
      </header>
    </div>
  );
};

export default Navbar;
